/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	AcademicUser,
	AcademicUserFromJSON,
	AcademicUserFromJSONTyped,
	AcademicUserToJSON,
} from "./AcademicUser";
import {
	Department,
	DepartmentFromJSON,
	DepartmentFromJSONTyped,
	DepartmentToJSON,
} from "./Department";
import {
	EmailPriority,
	EmailPriorityFromJSON,
	EmailPriorityFromJSONTyped,
	EmailPriorityToJSON,
} from "./EmailPriority";
import {
	EmailRecipient,
	EmailRecipientFromJSON,
	EmailRecipientFromJSONTyped,
	EmailRecipientToJSON,
} from "./EmailRecipient";
import {
	EmailSendStrategy,
	EmailSendStrategyFromJSON,
	EmailSendStrategyFromJSONTyped,
	EmailSendStrategyToJSON,
} from "./EmailSendStrategy";
import {
	Faculty,
	FacultyFromJSON,
	FacultyFromJSONTyped,
	FacultyToJSON,
} from "./Faculty";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";
import {
	StudyProgram,
	StudyProgramFromJSON,
	StudyProgramFromJSONTyped,
	StudyProgramToJSON,
} from "./StudyProgram";

/**
 *
 * @export
 * @interface NewsletterEmail
 */
export interface NewsletterEmail {
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmail
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof NewsletterEmail
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof NewsletterEmail
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmail
	 */
	publisherId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmail
	 */
	subject?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmail
	 */
	body?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmail
	 */
	newsletterChannel?: string | null;
	/**
	 *
	 * @type {EmailPriority}
	 * @memberof NewsletterEmail
	 */
	priority?: EmailPriority;
	/**
	 *
	 * @type {number}
	 * @memberof NewsletterEmail
	 */
	initialRecipientsCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof NewsletterEmail
	 */
	currentRecipientsCount?: number | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof NewsletterEmail
	 */
	expeditionEnabled?: boolean;
	/**
	 *
	 * @type {EmailSendStrategy}
	 * @memberof NewsletterEmail
	 */
	strategy?: EmailSendStrategy;
	/**
	 *
	 * @type {Role}
	 * @memberof NewsletterEmail
	 */
	recipientRole?: Role;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof NewsletterEmail
	 */
	years?: Array<StudentYearEnum> | null;
	/**
	 *
	 * @type {AcademicUser}
	 * @memberof NewsletterEmail
	 */
	publisher?: AcademicUser;
	/**
	 *
	 * @type {Array<EmailRecipient>}
	 * @memberof NewsletterEmail
	 */
	recipients?: Array<EmailRecipient> | null;
	/**
	 *
	 * @type {Array<Faculty>}
	 * @memberof NewsletterEmail
	 */
	faculties?: Array<Faculty> | null;
	/**
	 *
	 * @type {Array<Department>}
	 * @memberof NewsletterEmail
	 */
	departments?: Array<Department> | null;
	/**
	 *
	 * @type {Array<StudyProgram>}
	 * @memberof NewsletterEmail
	 */
	studyPrograms?: Array<StudyProgram> | null;
}

export function NewsletterEmailFromJSON(json: any): NewsletterEmail {
	return NewsletterEmailFromJSONTyped(json, false);
}

export function NewsletterEmailFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): NewsletterEmail {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		publisherId: !exists(json, "publisherId") ? undefined : json["publisherId"],
		subject: !exists(json, "subject") ? undefined : json["subject"],
		body: !exists(json, "body") ? undefined : json["body"],
		newsletterChannel: !exists(json, "newsletterChannel")
			? undefined
			: json["newsletterChannel"],
		priority: !exists(json, "priority")
			? undefined
			: EmailPriorityFromJSON(json["priority"]),
		initialRecipientsCount: !exists(json, "initialRecipientsCount")
			? undefined
			: json["initialRecipientsCount"],
		currentRecipientsCount: !exists(json, "currentRecipientsCount")
			? undefined
			: json["currentRecipientsCount"],
		expeditionEnabled: !exists(json, "expeditionEnabled")
			? undefined
			: json["expeditionEnabled"],
		strategy: !exists(json, "strategy")
			? undefined
			: EmailSendStrategyFromJSON(json["strategy"]),
		recipientRole: !exists(json, "recipientRole")
			? undefined
			: RoleFromJSON(json["recipientRole"]),
		years: !exists(json, "years")
			? undefined
			: json["years"] === null
			? null
			: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		publisher: !exists(json, "publisher")
			? undefined
			: AcademicUserFromJSON(json["publisher"]),
		recipients: !exists(json, "recipients")
			? undefined
			: json["recipients"] === null
			? null
			: (json["recipients"] as Array<any>).map(EmailRecipientFromJSON),
		faculties: !exists(json, "faculties")
			? undefined
			: json["faculties"] === null
			? null
			: (json["faculties"] as Array<any>).map(FacultyFromJSON),
		departments: !exists(json, "departments")
			? undefined
			: json["departments"] === null
			? null
			: (json["departments"] as Array<any>).map(DepartmentFromJSON),
		studyPrograms: !exists(json, "studyPrograms")
			? undefined
			: json["studyPrograms"] === null
			? null
			: (json["studyPrograms"] as Array<any>).map(StudyProgramFromJSON),
	};
}

export function NewsletterEmailToJSON(value?: NewsletterEmail | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		publisherId: value.publisherId,
		subject: value.subject,
		body: value.body,
		newsletterChannel: value.newsletterChannel,
		priority: EmailPriorityToJSON(value.priority),
		initialRecipientsCount: value.initialRecipientsCount,
		currentRecipientsCount: value.currentRecipientsCount,
		expeditionEnabled: value.expeditionEnabled,
		strategy: EmailSendStrategyToJSON(value.strategy),
		recipientRole: RoleToJSON(value.recipientRole),
		years:
			value.years === undefined
				? undefined
				: value.years === null
				? null
				: (value.years as Array<any>).map(StudentYearEnumToJSON),
		publisher: AcademicUserToJSON(value.publisher),
		recipients:
			value.recipients === undefined
				? undefined
				: value.recipients === null
				? null
				: (value.recipients as Array<any>).map(EmailRecipientToJSON),
		faculties:
			value.faculties === undefined
				? undefined
				: value.faculties === null
				? null
				: (value.faculties as Array<any>).map(FacultyToJSON),
		departments:
			value.departments === undefined
				? undefined
				: value.departments === null
				? null
				: (value.departments as Array<any>).map(DepartmentToJSON),
		studyPrograms:
			value.studyPrograms === undefined
				? undefined
				: value.studyPrograms === null
				? null
				: (value.studyPrograms as Array<any>).map(StudyProgramToJSON),
	};
}
